<template>
  <AppContainer max-width="max-w-3xl">
    <form
      autocomplete="off"
      @submit.prevent="submitForm"
    >
      <AppCard>
        <TextInput
          v-model.trim="formData.name"
          label="Name"
          required
          :class="{ 'input-error': hasValidationError('name') }"
          :validation-error="getValidationError('name') || null"
        />

        <SelectInput
          v-model="formData.type"
          label="Type of Municipality"
          required
          :options="municipalityTypeOptions"
          :class="{ 'input-error': hasValidationError('type') }"
          :validation-error="getValidationError('type') || null"
        />

        <TextInput
          v-model.trim="formData.powerBiRegionLookupValue"
          label="PowerBi Region Lookup Value"
          :class="{ 'input-error': hasValidationError('powerBiRegionLookupValue') }"
          :validation-error="getValidationError('powerBiRegionLookupValue') || null"
        />

        <template #buttons>
          <ButtonSubmitRow
            :processing="isSubmitting"
            :cancel-route="{ name: 'app_municipality_list' }"
          />
        </template>
      </AppCard>
    </form>
  </AppContainer>
</template>

<script setup>
import { reactive } from 'vue';

import { AppContainer } from '@/components/app';
import { AppCard } from '@/components/cards';
import { ButtonSubmitRow } from '@/components/buttons';

import { useFormSubmit } from '@/composables';
import { SelectInput, TextInput } from '@/components/form-inputs';
import { MunicipalityType } from '@/const';

const props = defineProps({
  model: {
    type: Object,
    default: () => null,
  },
});

const { isSubmitting, submit, hasValidationError, getValidationError } = useFormSubmit();

const municipalityTypeOptions = [
  { label: MunicipalityType.Municipality, value: MunicipalityType.Municipality },
  { label: MunicipalityType.DistrictMunicipality, value: MunicipalityType.DistrictMunicipality },
];

const formData = reactive({
  name: props.model?.name || null,
  type: props.model?.type || null,
  powerBiRegionLookupValue: props.model?.powerBiRegionLookupValue || null,
});

const submitForm = async () => {
  await submit(props.model?.id, formData, 'app_municipality_list', 'municipalities');
};

</script>
